module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ws-panel"
  }, [_c('header', {
    staticClass: "ws-panel-heading",
    class: {
      'hidden': _vm.hideHeader
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t"), (_vm.rebak) ? _c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right head-actions"
  }, [_vm._t("panel_head_actions")], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "ws-panel-body"
  }, [_vm._t("panel_query"), _vm._v(" "), _vm._t("panel_body"), _vm._v(" "), (_vm.showPage) ? _c('div', {
    staticClass: "ws-pagination"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.page.pageNum,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.page.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-69fda359!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/panel.vue
// module id = 310
// module chunks = 99 100